import {
  FETCH_ORDERS,
  FETCH_ORDERS_SUCCESS,
  FETCH_ORDERS_FAILURE,
  SET_FITER_VALUES,
  SET_SELECTED_ORDERS,
  SET_SELECTED_ALL_ORDERS,
  UPDATE_STATUS_SUCCESS,
  GET_ORDER_BY_ID,
  SET_SEARCH_VALUE,
  GET_ORDER_BY_ID_SUCCESS,
  GET_ORDER_BY_ID_FAILURE,
  CLEAR_SELECTED_ORDERS,
  SET_SELECTED_ORDER_PRODUCT,
  REFUND_PRODUCTS_SUCCESS,
  REFUND_ORDER_SUCCESS,
  CLEAR_SEELECTED_ORDER_PRODUCTS,
  UPDATE_PAYMENT_STATUS,
  UPDATE_PAYMENT_STATUS_SUCCESS,
  CLEAR_FILTER_VALUES
} from "../constants/orderActionsType";

import { order as initialState } from "../constants/initialStates";
import _ from "lodash";
import moment from "moment";

export const orderReducer = (state = initialState, { data, error, type }) => {
  switch (type) {
    case FETCH_ORDERS:
      return {
        ...state,
        ordersActions: {
          isLoading: true,
          error: ""
        }
      };

    case FETCH_ORDERS_SUCCESS:
      const filterItems = [];
      data.results.forEach(order => {
        state.selectedOrders.forEach(selectedOrder => {
          if (selectedOrder.id === order.id) {
            filterItems.push({ id: order.id })
          }
        });
      });
      return {
        ...state,
        orders: data,
        ordersActions: {
          isLoading: false,
          error: ""
        },
        // selectedOrders: filterItems
      };

    case FETCH_ORDERS_FAILURE:
      return {
        ...state,
        ordersActions: {
          isLoading: false,
          error
        }
      };

    case SET_FITER_VALUES:
      const key = Object.keys(data)[0];
      const value = Object.values(data)[0];

      return {
        ...state,
        filterValues: {
          ...state.filterValues,
          [key]: value,
        },
      };

    case SET_SELECTED_ALL_ORDERS:
      const allOrder = data.filter
      let orderSelect = []
      if(data.active) {
        for (let index = 0; index < allOrder.length; index++) {
          const {id, status} = allOrder[index]
          orderSelect.push({id, status});
        }
      }
      
      return {
        ...state,
        selectedOrders: [...orderSelect]
      };

    case SET_SELECTED_ORDERS:
      const items = state.selectedOrders;
      const index = items.map(i => i.id).indexOf(data.id);
      if (index < 0) {
        items.push(data);
      } else {
          items.splice(index, 1);
      }
      return {
        ...state,
        selectedOrders: items
      };
    case SET_SEARCH_VALUE:
      return {
        ...state,
        filterValues: {
          ...state.filterValues,
          search: data,
          end: null,
          start: null,
          sortBy: {
            value: null,
            label: "Mayor"
          },
          status: {
            value: null,
            label: "Todas"
          }
        }
      };

    case UPDATE_STATUS_SUCCESS:
      const { ids, status } = data;
      const orderCopy = state.order;
      const orders = [...state.orders.results];
      const order = _.isEmpty(orderCopy) ? {} : { ...orderCopy, status };

      orders.forEach((value, i) => {
        if (ids.indexOf(value.id) !== -1) {
          if (status === "delivered") {
            orders[i].status = status;
            orders[i].delivered_at = moment().format();
          } else {
            orders[i].status = status;
          }
        }
      });

      return {
        ...state,
        order,
        orders: {
          ...state.orders,
          results: orders
        },
        selectedOrders: []
      };

    case GET_ORDER_BY_ID:
      return {
        ...state,
        ordersActions: {
          isLoading: true,
          error: ""
        }
      };
    case GET_ORDER_BY_ID_SUCCESS:
      return {
        ...state,
        order: data,
        ordersActions: {
          isLoading: false,
          error: ""
        }
      };
    case GET_ORDER_BY_ID_FAILURE:
      return {
        ...state,
        order: data,
        ordersActions: {
          isLoading: false,
          error: ""
        }
      };

    case CLEAR_SELECTED_ORDERS:
      return {
        ...state,
        selectedOrders: []
      };

    case SET_SELECTED_ORDER_PRODUCT: {
      const items = state.selectedProducts;
      const index = state.selectedProducts
        .map(product => product.id)
        .indexOf(data.id);
      if (index < 0) {
        items.push(data);
      } else {
        items.splice(index, 1);
      }
      return {
        ...state,
        selectedProducts: items
      };
    }

    case REFUND_ORDER_SUCCESS:
      return {
        ...state,
        order: {
          ...state.order,
          payment_status: "refunded"
        },
        selectedProducts: []
      };
    case REFUND_PRODUCTS_SUCCESS:
      return {
        ...state,
        order: data,
        selectedProducts: []
      };

    case CLEAR_SEELECTED_ORDER_PRODUCTS: {
      return {
        ...state,
        selectedProducts: []
      };
    }
    case CLEAR_FILTER_VALUES: {
      return {
        ...state,
        filterValues: {
          ...state.filterValues,
          // merchant: {},
          // store: {},
          search: "",
          end: null,
          start: null,
          sortBy: {
            value: null,
            label: "Mayor"
          },
          status: {
            value: null,
            label: "Todas"
          },
          paymentStatus: {
            value: null,
            label: "Todas"
          }
        }
      };
    }
    case UPDATE_PAYMENT_STATUS:
      return {
        ...state,
        orderActions: {
          ...state.ordersActions,
          isLoading: true
        }
      };

    case UPDATE_PAYMENT_STATUS_SUCCESS: {
      const { orderId, status } = data;
      const orders = [...state.orders.results];
      const index = orders.findIndex(order => order.id === orderId);
      orders[index].payment_status = data.status;
      const order = _.isEmpty(state.order)
        ? {}
        : { ...state.order, payment_status: status };
      return {
        ...state,
        orderActions: {
          ...state.ordersActions,
          isLoading: false
        },
        order,
        orders: {
          ...state.orders,
          results: orders
        }
      };
    }

    default:
      return state;
  }
};
